(() => {
  'use strict';

  // A region's permissive default is not an explicit choice by the visitor.
  const preferencesAllowed = () => {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      return privacy?.currentVisitorConsent().preferences === 'yes' &&
        privacy.preferencesProcessingAllowed() === true;
    } catch {
      return false;
    }
  };

  const disableMap = (map) => {
    map.querySelector('iframe[data-zb-map-frame]')?.remove();
    map.querySelector('[data-zb-map-placeholder]').hidden = false;
    map.querySelector('[data-zb-map-withdraw]').hidden = true;
  };

  const update = () => {
    const allowed = preferencesAllowed();
    document.querySelectorAll('[data-zb-map]').forEach((map) => {
      if (!allowed) disableMap(map);
      map.querySelector('[data-zb-map-activate]').textContent = allowed
        ? 'Google Maps laden' : 'Cookie-Einstellungen öffnen';
    });
    if (!allowed) {
      document.querySelectorAll('[ref="recentlyViewedWrapper"]').forEach((node) => node.remove());
    }
    document.dispatchEvent(new CustomEvent('zentrobad:privacy-change', { detail: { preferencesAllowed: allowed } }));
  };

  const openSettings = async (trigger) => {
    const status = trigger?.closest('[data-zb-map]')?.querySelector('[data-zb-privacy-status]');
    if (status) status.textContent = '';
    try {
      if (typeof window.privacyBanner?.showPreferences === 'function') {
        await window.privacyBanner.showPreferences();
        return;
      }
      // Shopify's native footer link remains usable while its script initializes.
      window.location.hash = 'shopifyReshowConsentBanner';
      if (status) status.textContent = 'Falls sich die Einstellungen nicht öffnen, lade bitte die Seite neu. Die Karte bleibt bis zur Zustimmung ausgeschaltet.';
    } catch {
      if (status) status.textContent = 'Die Cookie-Einstellungen sind gerade nicht erreichbar. Bitte versuche es erneut. Die Karte bleibt ausgeschaltet.';
    }
  };

  window.ZentrobadPrivacy = Object.freeze({ preferencesAllowed, openSettings });

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const settings = target?.closest('[data-zb-privacy-settings]');
    if (settings) {
      event.preventDefault();
      void openSettings(settings);
      return;
    }
    const activate = target?.closest('[data-zb-map-activate]');
    if (activate) {
      const map = activate.closest('[data-zb-map]');
      if (!preferencesAllowed()) {
        void openSettings(activate);
        return;
      }
      if (map.querySelector('iframe[data-zb-map-frame]')) return;
      const frame = document.createElement('iframe');
      frame.title = 'Zentrobad Standort Dormagen – Google Maps';
      frame.setAttribute('data-zb-map-frame', '');
      frame.loading = 'lazy';
      frame.referrerPolicy = 'no-referrer';
      // Assigning src happens only after this explicit click AND current consent.
      frame.src = map.dataset.zbMapSrc;
      map.append(frame);
      map.querySelector('[data-zb-map-placeholder]').hidden = true;
      map.querySelector('[data-zb-map-withdraw]').hidden = false;
      return;
    }
    const withdraw = target?.closest('[data-zb-map-withdraw]');
    if (withdraw) {
      const map = withdraw.closest('[data-zb-map]');
      disableMap(map);
      map.querySelector('[data-zb-map-activate]').focus();
    }
  });

  document.addEventListener('visitorConsentCollected', update);
  document.addEventListener('shopify:section:load', update);
  window.addEventListener('pageshow', update);

  const loadPrivacy = () => {
    if (window.Shopify?.customerPrivacy) {
      update();
    } else if (typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => update());
    }
  };
  loadPrivacy();
  window.addEventListener('load', loadPrivacy, { once: true });
})();
